
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function SubheadingDistribution(subheadings:number = 0) {

    return analyze;

    function analyze(tree:any, file:any){

        let result:TextAnalysis = getSubheadingText(subheadings);

        if(result.result === TextAnalysisResult.improvement){ 
            file.improvements.push(result);
        } else { 
            file.goodResults.push(result);
        }

        function getSubheadingText(subheadings: number) {
            let result:TextAnalysis = {title: TextAnalysisCategory.subheading_distribution, displayText: "", helperText: "The number of subheading tags found"};
            if (subheadings === 0){
                result.displayText = "I don’t see any subheadings in your sermon. This may not be an issue if you’re already formatting your main points with something other than the H2 tag. Otherwise, try to mark each main point as a heading with the H2 formatting option in the editor.";
                result.result = TextAnalysisResult.improvement;
            } else {
                result.result = TextAnalysisResult.goodResult;
                result.displayText = "Perfect, it looks like you’re using the H2 formatting tag for your main preaching points.";
            }
            return result;
        }
    }
}



